import * as moment from 'moment';
import { FormEvent } from 'react';
import { Alert, Button, Col, ControlLabel, Form, FormControl, FormGroup, Well } from 'react-bootstrap';
import * as DateTimeModule from 'react-datetime';
import { DISPLAY_FORMAT, STORAGE_FORMAT, isWeekend } from '@nkr/utils/blood-draw-validation';
import { InternalDirectAction } from '../../../models';

interface IProps {
    action: InternalDirectAction,
    donationDate: string,
    onChangeDonationDate: (donationDate: string) => void,
    onSubmit: () => void,
    onCancel: () => void
}

const DateTime = (DateTimeModule as any).default || DateTimeModule;

const UpdateRow = (props: IProps) => {
    const tomorrow = moment().startOf('day').addDays(1);
    const isChangeDonationDate = props.action == InternalDirectAction.ChangeDonationDate;
    const isWeekendDate = isChangeDonationDate && moment(props.donationDate, STORAGE_FORMAT, true).isValid() && isWeekend(moment(props.donationDate, STORAGE_FORMAT));

    const handleDonationDateChange = (e: FormEvent<FormControl & HTMLInputElement>) => {
        props.onChangeDonationDate(e.currentTarget.value);
    };

    const handleNewDonationDateChange = (value: moment.Moment | string) => {
        if (moment.isMoment(value)) {
            props.onChangeDonationDate(value.format(STORAGE_FORMAT));
            return;
        }

        const parsed = moment(value, DISPLAY_FORMAT, true);
        props.onChangeDonationDate(parsed.isValid() ? parsed.format(STORAGE_FORMAT) : '');
    };

    const validDonationDate = () => {
        const donationDate = moment(props.donationDate, 'YYYY-MM-DD');

        // if donationDate is not valid return false
        if (!donationDate.isValid()) {
            return false;
        }

        // Mark completed should only allow the surgery date
        if (props.action == InternalDirectAction.MarkCompleted) {
            return donationDate.isValid();
        }

        // Change donation date should only allow future weekdays
        if (props.action == InternalDirectAction.ChangeDonationDate) {
            return donationDate.isSameOrAfter(tomorrow) && !isWeekend(donationDate);
        }

        // All other dates/actions combinations are allowed
        return true;
    }

    return (
        <tr>
            <td colSpan={7}>
                <Well bsSize='sm' style={{ marginBottom: 0 }}>
                    <h4 style={{ marginTop: 5 }}>{props.action == InternalDirectAction.MarkCompleted ? 'Mark Donation Completed' : 'Set New Donation Date'}</h4>

                    <Form horizontal>
                        <FormGroup>
                            <Col xs={12} lg={4} componentClass={ControlLabel}>Donation Date:</Col>
                            <Col xs={12} lg={4}>

                                {isChangeDonationDate
                                    ? <DateTime
                                        value={props.donationDate ? moment(props.donationDate, STORAGE_FORMAT) : null}
                                        dateFormat={DISPLAY_FORMAT}
                                        timeFormat={false}
                                        strictParsing={true}
                                        isValidDate={(currentDate: moment.Moment) => currentDate.isSameOrAfter(tomorrow) && !isWeekend(currentDate)}
                                        onChange={handleNewDonationDateChange}
                                        inputProps={{
                                            className: 'form-control',
                                            placeholder: DISPLAY_FORMAT
                                        }}
                                        closeOnSelect={true}
                                    />
                                    : <FormControl
                                        type='date'
                                        value={props.donationDate}
                                        min={props.action == InternalDirectAction.MarkCompleted ? moment(props.donationDate).format("YYYY-MM-DD") : tomorrow.format("YYYY-MM-DD")}
                                        max={props.action == InternalDirectAction.MarkCompleted ? moment(props.donationDate).format("YYYY-MM-DD") : undefined}
                                        onChange={handleDonationDateChange}
                                    />
                                }

                                <Alert hidden={validDonationDate()}
                                    style={{marginTop: '15px' }}
                                    bsStyle="warning">
                                        {props.action == InternalDirectAction.MarkCompleted ? 'Date must match the current donation date.' : isWeekendDate ? 'Donation date cannot fall on a weekend.' : 'Date must be in the future.'}
                                </Alert>
                                <Alert hidden={props.action != InternalDirectAction.MarkCompleted}
                                    style={{marginTop: '15px'}}
                                    bsStyle='info'>
                                        This date is locked to the current donation date.
                                </Alert>
                            </Col>
                        </FormGroup>
                    </Form>

                    <Button bsStyle='success' disabled={!validDonationDate()} onClick={props.onSubmit}>Submit</Button>&nbsp;
                    <Button onClick={props.onCancel}>Cancel</Button>
                </Well>
            </td>
        </tr>
    );
}

export default UpdateRow;